import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  campaignList: [],
  categoryList: [],
  selectAdvCategory: "",
  selectCampaign: "",
};

const AdvertismentReducer = createSlice({
  name: "AdvertismentReducer",
  initialState: initialState,
  reducers: {
    setCampaignList: (state, { payload }) => {
      return {
        ...state,
        campaignList: payload,
      };
    },
    setCampaign: (state, { payload }) => {
      return {
        ...state,
        selectCampaign: payload,
      };
    },
    addList: (state, { payload }) => {
      console.log("payload", payload);
      return {
        ...state,
        campaignList: [...state.campaignList, payload],
      };
    },
    setAdvCategoryList: (state, { payload }) => {
      return {
        ...state,
        categoryList: payload,
      };
    },

    addAdvCategoryList: (state, { payload }) => {
      console.log("payload", payload);
      return {
        ...state,
        categoryList: [...state.categoryList, payload],
      };
    },

    setAdvCategory: (state, { payload }) => {
      return {
        ...state,
        selectAdvCategory: payload,
      };
    },
    clearedSelectItems: (state) => {
      return {
        ...state,
        selectAdvCategory: "",
        selectCampaign: "",
      };
    },
  },
});
export default AdvertismentReducer;
